<script setup lang="ts">
const props = defineProps<{
  on?: boolean
}>()
</script>

<template>
  <svg viewBox="0 0 24 24" aria-hidden="true" fill="currentColor">
    <path v-if="on" d="m12.0025 4 2.8593 4.9091 5.5524 1.2024-3.7852 4.2363L17.2012 20l-5.1987-2.2909L6.8038 20l.5723-5.6522-3.7853-4.2363 5.5524-1.2024L12.0025 4z" />
    <path
      v-else
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.8589 8.9091 11.9996 4 9.1403 8.9091l-5.5524 1.2024 3.7853 4.2363L6.8008 20l5.1987-2.2909L17.1983 20l-.5723-5.6522 3.7853-4.2363-5.5524-1.2024zm1.7718 2.4307-3.0569-.6619-1.5742-2.7028-1.5742 2.7028-3.057.6619 2.084 2.3324-.315 3.1119 2.8622-1.2613 2.8622 1.2613-.3151-3.1119 2.084-2.3324z"
    />
  </svg>
</template>
